import { LogLevel } from '@shared/enums/LogLevel';
import { AppinsightsLoggingService } from '@core/services/appinsights-logging.service';
import { ConsoleLoggingService } from '@core/services/console-logging.service';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'dev',
  // API_ENDPOINT: 'https://devapi.whataburgerdigital.net/latestr2',
  API_ENDPOINT: 'https://devapi.whataburgerdigital.net/v2.4', // 2.3 causing issue, server team asked to changed to 2.2
  SignalR_HUB : 'https://devhubcore.whataburgerdigital.net/NotificationHub',
  // this is just filler for now. TODO replace with the proper API endpoint when it is created.
  WEBADMIN_ENDPOINT: 'https://devapi.whataburgerdigital.net/denali/',
  WBCRM_KEY: '2f2557b2-ddc6-487c-b648-0234fe3a8777',
  IMG_ENDPOINT: 'https://devimageserver.whataburgerdigital.net',
  API_KEY: '9024B9FA-66F5-485C-BD70-6BC2F8BFFDDA',
  AppName: 'Whataburger',
  FB_KEY: '206569129724299',
  FB_API_VERSION: 'v2.2',
  GP_API_KEY: 'AIzaSyBfYeBr8Uk3uTK_gqwooSybWZ0w1eufeKU',
  GP_CLIENT_ID: '882148107299-j8u0763vgo5fcvr8usk2uema70c81dqf.apps.googleusercontent.com',
  GP_SCOPES: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/user.birthday.read profile',
  VerboseTracing: true,
  UseMockBackend: true,
  MAX_MOBILE_WIDTH: 991, // magic number bootstrap break point for tablet and mobile view versus desktop view size  
  OVERLAY_LENGTH: 3000, // display the overlay for this many milliseconds
  GTM_Code: 'GTM-MSPM8XM',
  STRIPE_KEY: 'pk_test_M53b7vGlOGTr7u3AdbTLiAdg',
  DEFAULT_ZOOM: 13,
  FORCEHTTPS: false,
  PAYPAL_ClIENT_ID: 'Ad3lW6npyXQ3zg4HQ_wxU8kDk0KHeUN9i1uzdxesJdIaAnvwu245UPy5kUDM0mhFoYjDL3eH0y93cSDH',
  PAYPAL_ENVIRONMENT: 'sandbox',
  // PAYPAL_RETURN_URL: 'http://localhost:4200/paypal/success'
  PAYPAL_RETURN_URL: 'https://devdotcom.whataburgerdigital.net/paypal/success',
  appInsightsConfig: {
    config: {
      instrumentationKey: 'b2d2d3ba-8422-4329-bef3-7c4778b17c72'
    }
  },
  chaseConfig: {
  javascriptRoot: `https://safetechpageencryptionvar.chasepaymentech.com/pie/v1`,
  chaseSubscriberId: '100000000278',
  formatPreserveFirst6Last4: '64'
  },
  defaultLogLevel: LogLevel.Verbose,
  loggingServiceProvider: AppinsightsLoggingService,
  showPaymentAddress: false,
  ONLINE_ORDER_DETAILS: 'https://stories.whataburger.com/were-bringing-you-a-new-way-to-order/',
  APPLE_SIGNIN_SERVICE_ID: 'com.whataburger.onlineordering-np',
  APPLE_SIGNIN_SCOPES: 'name email',
  APPLE_SIGNIN_REDIRECTURI: 'https://devidp.whataburgerdigital.net/auth/apple-sign-in/callback',
  DATE_FORMAT: 'M/D/YYYY',
  KOUNT_URL: 'https://tst.kaptcha.com/collect/sdk',
  KOUNT_MERCHANT_ID: '300681',
  CHASE_PAYMENT_CONFIG: [
    {
      supportedMethods: "https://apple.com/apple-pay",
      data: {
          version: 3,
          merchantIdentifier: "merchant.com.whataburger.paymentech",
          initiative: "web",
          merchantCapabilities: [
              "supports3DS"
          ],
          supportedNetworks: [
              "amex",
              "discover",
              "masterCard",
              "visa"
          ],
          "countryCode": "US"
      }
    },
    {
      supportedMethods: 'https://google.com/pay',
      data:
      {
        environment: 'TEST',
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: "CARD",
            parameters: {
              allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
              allowedCardNetworks: ["AMEX", "VISA", "MASTERCARD", "DISCOVER"]
            },
            tokenizationSpecification: {
              type: "PAYMENT_GATEWAY",
              parameters: {
                gateway: "chase",
                gatewayMerchantId: "700000013261"
              }
            }
          }
        ],
        merchantInfo: {
          merchantId: "03646201621534475102",
          merchantName: "Whataburger Restaurants LLC"
        }
      }
    }
  ],
  CONTACT_US_VERSION: '1.2',
  ciamSocialMigrationRetryMinutes: 60,
  statsig: {
    clientSdkKey: 'client-TtjQECdAr19AKdyRxbteguO6rzqpnJ2OH8ttKUT6IyH',
    environmentTier: 'development'
  },
  //Auth0 magic link: OneLink redirect_uri (must match Auth0 allowlist, CCT send, and callback POST)
  ciamMagicLinkRedirectUri: 'https://devdotcom.whataburgerdigital.net?AppLink=magicLink',
  features: {
    deliveryFrontOfFlow: true
  },
    braze: {
        API_KEY: '6f43055c-2518-4a60-821c-04b92288d048',
        SDK_ENDPOINT: 'sdk.iad-06.braze.com',
        SAFARI_WEBSITE_PUSH_ID: 'web.com.whataburger.safaripush'
    },
    NOTIFICATIONS_SETTINGS_URL:"https://whataburgerdigital.page.link/NotificationSettings",
    USABLENET_STATEMENT_SCRIPT_URL: 'https://a40.usablenet.com/pt/c/statement/whataburger/accessibilitystatement.js?l=1',
    USABLENET_WIDGET_ID: 'usntA40Toggle',
    MAX_PHONE_WIDTH: 767,
    DISABLE_PAYPAL: false,
    LOYALTY_MODE: 2,
    RADAR: {
      API_KEY: 'prj_test_pk_db71342818a190fefef83612cfff9c3672eaf1e3',
      UI: {
        container: 'search',
        showMarkers: true,
        markerColor: '#ACBDC8',
        responsive: true,
        width: '100%',
        maxHeight: '600px',
        placeholder: 'City, State or Zipcode',
        limit: 8,
        minCharacters: 1,
        near: null,
        layers: ["address", "locality", "state", "postalCode"],
        countryCode:'US',
      }
    },
    Campaign: {
      CATABOOM_GAME_CTA: 'https://whataburgerdigital.page.link/ScoreMore',
      CATABOOM_GAME_RULES: 'https://stories.whataburger.com/score-more-official-rules-2023/'
    },
    paze: {
      SCRIPT_URL: 'https://sandbox.digitalwallet.earlywarning.com/web/resources/js/digitalwallet-sdk.js',
      client: {
        id : "DJH5RMAVFEKMZT4RH7O413ONvj6FYTpFFERzlqwpQGSGPqMkM",
        name : "Whataburger",
        profileId : "whataburgerdev"
      }
    },
    BraintreeTokenizationKey: "sandbox_248c3m8w_95nqjx3jshdwbfff",
    oneTrust: {
      autoBlockSrc: null,
      mainSrc: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      domainAttribute: '0198a415-cb70-7997-b0b2-e6decf848abb'
    },
    qualtrics: {
      src: 'qualtrics-nonprod.js'
    },
    TalkDesk: {
      SCRIPT_SRC: 'https://talkdeskchatsdk.talkdeskapp.com/v2/talkdeskchatsdk.js',
      TouchpointId: 'c6efb4e2b7f343749a35b049773d8d1c',
      Region: 'td-us-1'
    }
};
